module.exports = __webpack_public_path__ + "img/amex.c.518ea500.png";